const modelName = 'Subscriptions';
const modelNameSingular = 'Subscription';
const endpoint = '/subscriptions';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: true,
    canAddNew: false,
    canSearch: true,
    endpoint,
    accessor: 'id',
};

export default setup;
